<template>
    <div class="form">
        <h4 class="step-title">
            Have you had a DUI?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row">
            <yes-no-button-list v-bind:onclick="complete"></yes-no-button-list>
        </div>
    </div>
</template>

<script>
    import YesNoButtonList from "./shared/YesNoButtonList.vue"

    export default {
        name: "Dui",
        components: {
            YesNoButtonList
        },
        props: {
            lead: Object
        },
        methods: {
          complete: function(dui) {
              this.lead.dui = dui;
              this.$emit("complete", this.$options.name, dui);
          }
        }
    }
</script>
